import { Stack, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';
import theme from 'shared/styles/theme';

const AdvanceInTheWorksScreen = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('advance', {
    keyPrefix: 'advanceInTheWorksStrings',
  });

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <SuccessScreen
        primaryButton={{
          label: translatedText('doneButton'),
          onPress: () => {
            router.navigate('/');
          },
          analyticsId: 'gotoHomeClicked',
          customAttributes: { cta: 'Done' },
        }}
        visual="HOURGLASS_A"
        titleText={translatedText('title')}
        content={
          <BodyBaseText numberOfLines={0} style={styles.contentText}>
            {translatedText('description')}
          </BodyBaseText>
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  contentText: {
    textAlign: 'center',
  },
});

export default AdvanceInTheWorksScreen;
